/**
 * Step progress line for wizards; text is supplied by caller (often ICU output).
 *
 * @param label - Fully formatted progress string (**`Translate`** output).
 * @returns **`p`** with **`role=status`** and **`qz-progress`** class.
 */
export function createProgress(label: string): HTMLParagraphElement {
  const p = document.createElement("p");
  p.className = "qz-progress";
  p.setAttribute("role", "status");
  p.textContent = label;
  return p;
}
